module.exports = __webpack_public_path__ + "img/man-sit.bf1cb9b3.png";